import * as amplitude from "@amplitude/analytics-browser";
import { Button } from "@chakra-ui/react";
import { RiEdit2Line, RiSearchEyeLine } from "react-icons/ri";
import { Link as RouterLink } from "react-router-dom";
import { Glossary } from "src/components/Text/Glossary";
import { useOrganization } from "src/hooks/useOrganization";
import { isInProgressAndCanEditCheck } from "src/scenes/parent/forms/formEditability";
import * as Url from "src/services/url";
import * as GQL from "src/types/graphql";

interface CardActionProps {
  form: Pick<
    GQL.GetParentFormsIndex_person_forms,
    "id" | "status" | "form_template"
  >;
}

export function CardAction(props: CardActionProps) {
  const { form } = props;

  const organization = useOrganization();

  const sections = form.form_template.sections.map((section) => ({
    family_editable_statuses:
      (section.family_editable_statuses as GQL.form_status_enum[] | null) ??
      undefined,
  }));

  const enrollmentPeriod = form.form_template.enrollment_period;

  const canResume = isInProgressAndCanEditCheck(
    sections,
    enrollmentPeriod,
    form.status
  );

  if (canResume) {
    return (
      <Button
        as={RouterLink}
        colorScheme="gray"
        leftIcon={<RiEdit2Line />}
        size="sm"
        to={organization
          .map((org) => Url.Parent.Form.edit(org, form.id))
          .withDefault("#")}
        variant="outline"
        width="100%"
        onClick={() => {
          amplitude.track("Resume form clicked", {
            button_location: "form_card",
          });
        }}
      >
        <Glossary>Resume form</Glossary>
      </Button>
    );
  }
  return (
    <Button
      as={RouterLink}
      colorScheme="gray"
      leftIcon={<RiSearchEyeLine />}
      size="sm"
      to={organization
        .map((org) => Url.Parent.Form.view(org, form.id))
        .withDefault("#")}
      variant="outline"
      width="100%"
      onClick={() => {
        amplitude.track("View form clicked", {
          button_location: "form_card",
        });
      }}
    >
      <Glossary>View form</Glossary>
    </Button>
  );
}
